// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"18dd04d5","453":"889e2dbd","455":"70f902a8"}[chunkId] + ".chunk.js";
};